import React from 'react';
import _ from 'lodash';
import { SelectField, RadioField, TextField, DateField } from 'src/jbc-front/components/Form';
import { BANK_SELECTS, KBANK_SELECT_SERVICES, KBANK_TRANSFER_TYPES, KRUNGSRI_SELECT_SERVICES, SMBC_SELECT_SERVICE, BANGKOK_SELECT_SERVICES, SCB_SELECT_SERVICE, DIRECT_CREDIT, PAYEE_CHARGE_CODE, CUT_OFF_TIME, ICASH_TYPE, CASH_LINK_FORMAT, IS_SAME_DAY } from 'src/constants/Options';
import { maxLength7, maxLength12, maxLength20, maxLength25, alphaNumeric, capitalAlphaNumericSymbol, isNumber, exactLength12 } from 'src/utils/CustomValidators';
import { useTranslation } from 'react-i18next';

const FbDataBankSelect = props => {
  const { selectBank, bankOptions } = props;
  const { t } = useTranslation();
  const selectOptions = bankOptions?.length ? bankOptions : BANK_SELECTS;

  return (
    <React.Fragment>
      <SelectField
        required
        name="bankSelect"
        label={t('components.FbDataBankSelect.bank_select')}
        options={selectOptions}
        onChange={selectBank}
        placeholder={t('components.FbDataBankSelect.please_select')}
      />
    </React.Fragment>
  );

};

export default FbDataBankSelect;